module.exports = __webpack_public_path__ + "img/inventarios.34f6b0e4.gif";